import { Pipe, PipeTransform } from '@angular/core';
import { AppCurrencyService } from 'src/app/@services/app-currency.service';

/**
 * Formats money via AppCurrencyService as `SYMBOL + amount + CODE`
 * (e.g. `$1,000.00 GYD`) from Settings > Currency Setting.
 * Impure so templates refresh after currency settings load/save.
 *
 * Usage: {{ amount | appMoney }}
 */
@Pipe({ name: 'appMoney', pure: false })
export class AppMoneyPipe implements PipeTransform {
  constructor(private currency: AppCurrencyService) {
    this.currency.ensureLoaded();
  }

  transform(value: unknown, _currencyCodeOrSymbol?: string | null): string {
    return this.currency.format(value, _currencyCodeOrSymbol);
  }
}
